"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSentiment = exports.postSentiment = void 0;
var helpers_1 = require("./helpers");
var constants_1 = require("./constants");
var client_platform_web_network_1 = require("@wattpad/client-platform-web-network");
/**
 * Validates the parameters for sentiment functions.
 * - sentimentType should be in SENTIMENT_TYPES
 * - namespace should be in SENTIMENT_NAMESPACES
 *
 * Rejects with error and logs if not valid.
 *
 * @param sentimentType Type of sentiment.
 * @param namespace Resource namespace.
 * @param id Id of a resource.
 * @param funcName Name of the calling function. Will be logged on failed validation.
 * @returns Rejected Promise with error on failed validation. Undefined otherwise.
 */
function validateParams(sentimentType, namespace, id, funcName) {
    if (!sentimentType || !namespace || !id) {
        var errMessage = "client-platform-comments: ".concat(funcName, " Failed Missing parameter");
        var description = "Cannot have null/undefined valued parameters for ".concat(funcName);
        var logMessage = "client-platform-comments: ".concat(funcName, " Failed sentimentType: ").concat(sentimentType, ", namespace: ").concat(namespace, ", error: ").concat(description);
        return (0, helpers_1.invalidParam)(logMessage, errMessage, description);
    }
    else if (!Object.values(constants_1.SENTIMENT_TYPES).includes(sentimentType)) {
        var errMessage = "client-platform-comments: ".concat(funcName, " Invalid sentimentType");
        var description = "Given sentimentType does not exist in the SentimentTypes object";
        var logMessage = "client-platform-comments: ".concat(funcName, " Failed sentimentType: ").concat(sentimentType, ", namespace: ").concat(namespace, ", error: ").concat(description);
        return (0, helpers_1.invalidParam)(logMessage, errMessage, description);
    }
    else if (!Object.values(constants_1.SENTIMENT_NAMESPACES).includes(namespace)) {
        var errMessage = "client-platform-comments: ".concat(funcName, " Invalid namespace");
        var description = "Given namespace does not exist in the SentimentNamespaces object";
        var logMessage = "client-platform-comments: ".concat(funcName, "  Failed sentimentType: ").concat(sentimentType, ", namespace: ").concat(namespace, ", error: ").concat(description);
        return (0, helpers_1.invalidParam)(logMessage, errMessage, description);
    }
    else if (typeof id !== "string") {
        var errMessage = "client-platform-comments: ".concat(funcName, " Invalid id");
        var description = "id must be a string";
        var logMessage = "client-platform-comments: ".concat(funcName, " Failed sentimentType: ").concat(sentimentType, ", namespace: ").concat(namespace, ", error: ").concat(description);
        return (0, helpers_1.invalidParam)(logMessage, errMessage, description);
    }
}
// Error codes that will return data in json format per api spec
var errorsWithJsonResponse = [400, 401, 403, 422];
/**
 * Posts a sentiment to the indicated resource.
 *
 * @param {Resource} resource Resource that the sentiment is being posted to
 * @param resource.namespace Namespace of the resource. Valid namespaces are SENTIMENT_NAMESPACES
 * @param resource.resourceId Resource ID of the given resource
 * @param sentimentType The type of sentiment being posted. Valid namespaces are SENTIMENT_TYPES
 * @returns Returns true if successful. Rejected promise on failure.
 */
function postSentiment(resource, sentimentType) {
    return __awaiter(this, void 0, void 0, function () {
        var namespace, resourceId, options, responseData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    namespace = resource === null || resource === void 0 ? void 0 : resource.namespace;
                    resourceId = resource === null || resource === void 0 ? void 0 : resource.resourceId;
                    return [4 /*yield*/, validateParams(sentimentType, namespace, resourceId, "postSentiment")];
                case 1:
                    _a.sent();
                    options = {
                        url: (0, helpers_1.buildDomain)("/v5/comments/namespaces/".concat(namespace, "/resources/").concat(resourceId, "/sentiments/").concat(sentimentType)),
                        method: "PUT",
                        timeoutValue: constants_1.SHORT_TIMEOUT_VALUE,
                        errorsWithJsonResponse: errorsWithJsonResponse,
                    };
                    responseData = (0, client_platform_web_network_1.fetch)(options)
                        .then(function (responseData) {
                        if (responseData.resource &&
                            responseData.created) {
                            return !!responseData.resource.resourceId;
                        }
                        // handles 4xx api errors
                        var apiErr = {
                            error: responseData.error,
                            description: responseData.description,
                        };
                        return Promise.reject(apiErr);
                    })
                        .catch(function (errorResult) {
                        // network and abort errors have standard message fields
                        // errors from the v5 api have error and description fields
                        var error = errorResult.error || errorResult;
                        var description = errorResult.description || errorResult.message;
                        console.log("client-platform-comments: postSentiment Failed", "sentimentType:", sentimentType, "namespace:", namespace, "error: ", description);
                        var errResponse = {
                            error: error,
                            description: description,
                        };
                        return Promise.reject(errResponse);
                    });
                    return [2 /*return*/, responseData];
            }
        });
    });
}
exports.postSentiment = postSentiment;
/**
 * Removes a specified sentiment from the indicated resource.
 *
 * @param {Resource} resource Resource that the sentiment is being removed from
 * @param resource.namespace Namespace of the resource. Valid namespaces are SENTIMENT_NAMESPACES
 * @param resource.resourceId Resource ID of the given resource
 * @param sentimentType The type of sentiment being removed. Valid sentimentTypes are SENTIMENT_TYPES
 * @returns Returns true if successful. Rejected promise on failure.
 */
function removeSentiment(resource, sentimentType) {
    return __awaiter(this, void 0, void 0, function () {
        var namespace, resourceId, options, responseData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    namespace = resource === null || resource === void 0 ? void 0 : resource.namespace;
                    resourceId = resource === null || resource === void 0 ? void 0 : resource.resourceId;
                    return [4 /*yield*/, validateParams(sentimentType, namespace, resourceId, "removeSentiment")];
                case 1:
                    _a.sent();
                    options = {
                        url: (0, helpers_1.buildDomain)("/v5/comments/namespaces/".concat(namespace, "/resources/").concat(resourceId, "/sentiments/").concat(sentimentType)),
                        method: "DELETE",
                        timeoutValue: constants_1.SHORT_TIMEOUT_VALUE,
                        errorsWithJsonResponse: errorsWithJsonResponse,
                    };
                    responseData = (0, client_platform_web_network_1.fetch)(options)
                        .then(function (responseData) {
                        if (Object.keys(responseData).length === 0) {
                            return Promise.resolve(true);
                        }
                        var err = {
                            error: responseData.error,
                            description: responseData.description,
                        };
                        return Promise.reject(err);
                    })
                        .catch(function (errorResult) {
                        // network and abort errors have standard message fields
                        // errors from the v5 api have error and description fields
                        var error = errorResult.error || errorResult;
                        var description = errorResult.description || errorResult.message;
                        console.log("client-platform-comments: removeSentiment Failed", "sentimentType:", sentimentType, "namespace:", namespace, "error: ", description);
                        var err = {
                            error: error,
                            description: description,
                        };
                        return Promise.reject(err);
                    });
                    return [2 /*return*/, responseData];
            }
        });
    });
}
exports.removeSentiment = removeSentiment;
